import { CoreMenu } from '@core/types'
import { custMenu } from './cust'

export const menu: CoreMenu[] = custMenu